class UpsellCard {
  constructor(product, addToCartIcon, loaderIcon, errorMessage) {
    this.product = product;
    this.addToCartEvent = null;
    this.variantId = null;
    this.addToCartIcon = addToCartIcon;
    this.loaderIcon = loaderIcon;
    this.errorMessage = errorMessage;
  }

  connectedCallback() {}

  // cleanups
  disconnectedCallback() {
    if (this.addToCartElement) {
      this.addToCartElement.removeEventListener('click', () =>
        this.handleAddToCart()
      );
    }
  }

  create() {
    return this.handleRenderCard(this.product);
  }

  handleRenderCard(product) {
    const productCard = document.createElement('article');
    productCard.className = 'relative';

    const productLinked = document.createElement('a');
    productLinked.href = product.url;
    productLinked.tabIndex = -1;

    //get only the first option
    const firstOption = product.options[0]?.values[0] || '';

    productLinked.append(
      this.handleRenderProductImage({
        src: product.images[0],
        alt: product.title,
      }),
      this.handleRenderProductInfo({
        title: product.title,
        option: firstOption,
        prevPrice: product.compare_at_price || product.price,
        price: product.price,
      })
    );

    productCard.append(
      productLinked,
      this.handleRenderAddTocartButton(product.variants),
      this.handleRenderLoader(),
      this.handleRenderErrorMessage()
    );

    return productCard;
  }

  handleRenderProductImage({ src = '', alt = '' }) {
    const figureElement = document.createElement('figure');
    figureElement.className = 'aspect-[80/100] mb-2';
    figureElement.innerHTML = `
      <img src='${src}' alt='${alt}' class='object-cover w-full' loading='lazy' width='80' height='100' />
    `;

    return figureElement;
  }

  handleRenderProductInfo({
    title = '',
    price = '',
    prevPrice = '',
    option = '',
  }) {
    const contentElement = document.createElement('div');
    const isProductOnSale = prevPrice != price;
    const saleClass = isProductOnSale ? 'text-sale' : '';
    const renderOption = option
      ? `<p class='text-sm leading-[1.3]'>${option}</p>`
      : '';
    const renderSalePrice = isProductOnSale
      ? `<p class='text-sm leading-tight'>${this.handleFormatPrice(
          prevPrice
        )}</p>`
      : '';

    contentElement.innerHTML = `
        <p class='text-sm leading-tight mb-1'>${title}</p>
        ${renderOption}
        <div class='mb-1'><p class='text-sm leading-tight ${saleClass}'>${this.handleFormatPrice(
      price
    )}</p>
        ${renderSalePrice}
        </div>
    `;

    return contentElement;
  }

  handleRenderAddTocartButton(variants) {
    // Create new elements or text nodes
    const variantId = variants[0].id;
    const addToCartButton = document.createElement('button');
    const addToCartLabel = window.variantStrings.addTocart || 'Add To Cart';

    addToCartButton.type = 'button';
    addToCartButton.tabIndex = -1;
    addToCartButton.className = 'peer text-sm';
    addToCartButton.ariaDisabled = 'false';
    addToCartButton.setAttribute('aria-error', 'false');
    addToCartButton.ariaLabel = addToCartLabel;
    addToCartButton.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_12945_86798" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
<rect y="0.0395508" width="24" height="24" fill="#1C1B1F"></rect>
</mask>
<g mask="url(#mask0_12945_86798)">
<path d="M11.5 8.53955V5.53955H8.5V4.53955H11.5V1.53955H12.5V4.53955H15.5V5.53955H12.5V8.53955H11.5ZM7.30775 21.1551C6.88592 21.1551 6.53042 21.0105 6.24125 20.7213C5.95225 20.4321 5.80775 20.0767 5.80775 19.6551C5.80775 19.2332 5.95225 18.8777 6.24125 18.5886C6.53042 18.2996 6.88592 18.1551 7.30775 18.1551C7.72958 18.1551 8.085 18.2996 8.374 18.5886C8.66317 18.8777 8.80775 19.2332 8.80775 19.6551C8.80775 20.0767 8.66317 20.4321 8.374 20.7213C8.085 21.0105 7.72958 21.1551 7.30775 21.1551ZM16.6923 21.1551C16.2704 21.1551 15.915 21.0105 15.626 20.7213C15.3368 20.4321 15.1923 20.0767 15.1923 19.6551C15.1923 19.2332 15.3368 18.8777 15.626 18.5886C15.915 18.2996 16.2704 18.1551 16.6923 18.1551C17.1141 18.1551 17.4696 18.2996 17.7587 18.5886C18.0478 18.8777 18.1923 19.2332 18.1923 19.6551C18.1923 20.0767 18.0478 20.4321 17.7587 20.7213C17.4696 21.0105 17.1141 21.1551 16.6923 21.1551ZM2 3.53955V2.53955H4.448L8.54425 11.1551H15.1788C15.2943 11.1551 15.3968 11.1261 15.4865 11.0683C15.5763 11.0106 15.6532 10.9306 15.7172 10.8281L19.2135 4.53955H20.3538L16.5693 11.3741C16.4244 11.6177 16.236 11.8088 16.004 11.9473C15.772 12.0858 15.5181 12.1551 15.2423 12.1551H8.1L6.8845 14.3858C6.782 14.5396 6.77883 14.7063 6.875 14.8858C6.97117 15.0653 7.11542 15.1551 7.30775 15.1551H18.1923V16.1551H7.30775C6.72442 16.1551 6.28817 15.9101 5.999 15.4203C5.71 14.9306 5.70392 14.4358 5.98075 13.9358L7.4845 11.2551L3.80775 3.53955H2Z" fill="#1C1B1F"></path>
</g>
</svg>`;

    addToCartButton.addEventListener('click', () =>
      this.handleAddToCart({
        currentElement: addToCartButton,
        productVariantId: variantId,
      })
    );

    this.addToCartElement = addToCartButton;

    return addToCartButton;
  }

  handleAddToCart({
    productVariantId = '',
    quantity = 1,
    currentElement = null,
  }) {
    currentElement.ariaDisabled = 'true';

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: productVariantId, quantity: quantity }],
      }),
    };

    fetch('/cart/add.js', config)
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: productVariantId,
          cartData: response,
        });
      })
      .catch((e) => {
        this.addToCartElement.setAttribute('aria-error', 'true');
        console.error('AddToCartButton error: ', e);
      });
  }

  handleRenderLoader() {
    const loaderWrapper = document.createElement('div');
    loaderWrapper.className =
      'absolute w-full h-full flex justify-center items-center top-0 left-0 hidden peer-aria-disabled:block';

    loaderWrapper.innerHTML = `<div class='absolute w-full h-full flex justify-center items-center'>
    <div class='size-6'>
      <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
    </div>
    </div>`;

    return loaderWrapper;
  }

  handleRenderErrorMessage() {
    const errorWrapper = document.createElement('div');
    errorWrapper.className =
      'hidden text-red-600 peer-aria-[error=true]:block text-xs leading-tight';

    errorWrapper.innerHTML = `${this.errorMessage}`;

    return errorWrapper;
  }

  handleFormatPrice(price) {
    const currency_code = window.shopInformation.currency_code || 'SEK';
    const money_format = window.shopInformation.money_format || 'SEK';

    if (window.Shopify) {
      const formattedPrice = window.Shopify.formatMoney(price, money_format);

      // replace kr as we need the SEK
      const formattedPriceWithCurrency =
        currency_code === 'SEK'
          ? formattedPrice.replace('kr', currency_code)
          : formattedPrice;

      return formattedPriceWithCurrency;
    }

    return price;
  }
}
